export const notePermissions = {
    VIEW_NOTES: {
        key: 'notes.view',
        name: 'View Notes',
    },
    EDIT_NOTES: {
        key: 'notes.edit',
        name: 'Edit Notes',
    },
    DELETE: {
        key: 'notes.delete',
        name: 'Delete Notes',
    },
    EDIT_HOT_NOTE: {
        key: 'notes.edit_hot_note',
        name: 'Edit Hot Note',
    },
}